export const sportsbookConfig = {
    DK: {
        siteName: 'DraftKings',
        siteCSVUrl: 'https://www.draftkings.com/entry/upload'
    },
    FD: {
        siteName: 'FanDuel',
        siteCSVUrl: 'https://www.fanduel.com/upcoming'
    },
    YH: {
        siteName: 'Yahoo',
        siteCSVUrl: 'https://dffe-sports.media.yahoo.com/dailyfantasy/contests/upcoming'
    }
}